<template>
  <div class="main">

    <router-view :class="this.$store.getters.getterViewPerspectiveValue" />

  </div>
</template>

<script>

export default {
  name: 'Layout',
  components: {
  }
}
</script>

